<template>
  <div>
    <b-row class="text-muted small font-weight-bold mb-2 px-1">
      <b-col cols="5">Before</b-col>
      <b-col cols="2" class="text-center">Action</b-col>
      <b-col cols="5">After</b-col>
    </b-row>

    <div v-for="(relation, index) in relations" :key="index" class="mb-3">
      <small class="font-weight-bold text-dark">{{ formatDate(relation.date) }}</small>

      <b-card>
        <b-row align-v="center">
          <b-col cols="5">
            <div v-for="(voucher, i) in relation.before" :key="`before-${i}`" class="mb-2">
              <div v-if="voucher.kind === 'product'">
                <strong>{{ voucher.name }}</strong>
                <div class="small text-muted">Code: {{ voucher.code }}</div>
                <div class="small text-muted">Giftcard ID: {{ voucher.giftcard_id }}</div>
                <div v-if="voucher.location" class="small text-muted">Location: {{ voucher.location }}</div>
              </div>
              <div v-else>
                <strong>{{ voucher.name }} {{ voucher.code }}</strong>
                <div class="small text-muted">Giftcard ID: {{ voucher.giftcard_id }}</div>
              </div>
            </div>
          </b-col>

          <b-col cols="2" class="text-center">
            <b-badge variant="light" class="px-2">{{ relation.label }}</b-badge>
          </b-col>

          <b-col cols="5">
            <div v-for="(voucher, i) in relation.after" :key="`after-${i}`" class="mb-2">
              <div v-if="voucher.kind === 'product'">
                <strong>{{ voucher.name }}</strong>
                <div class="small text-muted">Bookingcode: {{ voucher.code }}</div>
              </div>
              <div v-else-if="voucher.kind === 'financial'">
                <strong>{{ voucher.name }}</strong>
              </div>
              <div v-else>
                <strong>{{ voucher.name }} {{ voucher.code }}</strong>
              </div>
            </div>
          </b-col>
        </b-row>

        <div v-if="relation.order_id" class="small text-muted mt-2">Order ID: {{ relation.order_id }}</div>
      </b-card>
    </div>
  </div>
</template>

<script>
import { formatDate } from '../page-helpers'

export default {
  name: 'GiftcardRelations',
  props: {
    relations: {
      type: Array,
      default: () => [],
    },
  },
  methods: { formatDate },
}
</script>
